import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { TrackerContext } from 'connect-dot-com-ui-components/context/TrackerContext';
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import { CUIFlex } from 'connect-dot-com-ui-components/Components/CUIFlex/CUIFlex';
import CUIConnectLogo from 'connect-dot-com-ui-components/Components/CUIConnectLogo/CUIConnectLogo';
import TopNav from './TopNav';
import LoginSignupButtons from '../AuthButtons/LoginSignupButtons';
import CUIRouterLink from 'connect-dot-com-ui-components/Components/CUIRouterLink/CUIRouterLink';

const SiteHeader = ({
  children
}) => {
  const {
    trackInteraction
  } = useContext(TrackerContext);
  return /*#__PURE__*/_jsxs(CUIBox, {
    padding: {
      base: 8,
      sm: 10
    },
    children: [/*#__PURE__*/_jsxs(CUIFlex, {
      direction: {
        base: 'row',
        md: 'row'
      },
      align: "center",
      width: "100%",
      justify: "space-between",
      children: [/*#__PURE__*/_jsxs(CUIRouterLink, {
        to: "/",
        onClick: () => trackInteraction('click header nav logo'),
        order: {
          base: 0,
          md: 0
        },
        maxW: {
          base: '100%',
          sm: '180px'
        },
        children: [/*#__PURE__*/_jsx(CUIConnectLogo, {
          alt: "Visit Connect.com homepage",
          width: "100%",
          display: {
            base: 'none',
            sm: 'block'
          }
        }), /*#__PURE__*/_jsx(CUIConnectLogo, {
          use: "icon",
          minWidth: "50px",
          display: {
            base: 'block',
            sm: 'none'
          }
        })]
      }), /*#__PURE__*/_jsx(CUIBox, {
        order: {
          base: 2,
          md: 1
        },
        children: /*#__PURE__*/_jsx(TopNav, {})
      }), /*#__PURE__*/_jsx(LoginSignupButtons, {
        order: {
          base: 1,
          md: 2
        },
        display: {
          base: 'none',
          md: 'flex'
        },
        py: {
          base: 4,
          md: 0
        },
        trackingIdentifier: "navigation-bar"
      })]
    }), children && /*#__PURE__*/_jsx(CUIFlex, {
      marginTop: 6,
      maxW: "1000px",
      ml: "auto",
      mr: "auto",
      children: children
    })]
  });
};

export default SiteHeader;